import React from 'react'
import { colors } from '../../theme'

export function EyeIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill={colors.white}
        fillRule="evenodd"
        d="M5.148 8.367C6.888 6.877 9.306 5.75 12 5.75s5.112 1.125 6.852 2.616c1.71 1.465 2.898 3.404 2.898 5.134 0 1.73-1.188 3.669-2.898 5.134-1.74 1.49-4.158 2.616-6.852 2.616s-5.112-1.126-6.852-2.617C3.438 17.168 2.25 15.228 2.25 13.5c0-1.728 1.188-3.668 2.898-5.133zm.976 1.139C4.577 10.83 3.75 12.392 3.75 13.5s.827 2.668 2.374 3.994c1.518 1.3 3.6 2.256 5.876 2.256 2.276 0 4.359-.955 5.876-2.255 1.547-1.325 2.374-2.886 2.374-3.995 0-1.11-.827-2.67-2.374-3.995-1.517-1.3-3.6-2.255-5.876-2.255-2.276 0-4.358.956-5.876 2.256z"
        clipRule="evenodd"
      />
      <path
        fill={colors.white}
        fillRule="evenodd"
        d="M8.25 13.5a3.75 3.75 0 117.5 0 3.75 3.75 0 01-7.5 0zM12 11.25a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5zM6.195 5.023a.75.75 0 011.046.173l1.298 1.81a.75.75 0 11-1.22.874L6.023 6.07a.75.75 0 01.173-1.047zM18.25 5.246a.75.75 0 01.172 1.046l-1.297 1.81a.75.75 0 11-1.22-.874l1.298-1.81a.75.75 0 011.046-.172zM12.004 2.75a.75.75 0 01.75.75v3a.75.75 0 01-1.5 0v-3a.75.75 0 01.75-.75z"
        clipRule="evenodd"
      />
    </svg>
  )
}
